import { component } from 'picoapp';
import getProductItemsFromClerkResponse from 'utils/get-product-items-from-clerk-response';
import { ClerkResponse } from '../../typescript/Clerk';

export default component(async (node) => {
  const upsellList = node.querySelector('[data-upsell-list]');

  interface CartUpsellConfig {
    clerkLabel: string
    limit: number
    productIds: number[]
  }

  const config: CartUpsellConfig = JSON.parse(node.dataset.config);
  const { clerkLabel, limit, productIds } = config;

  const fetchProductItems = () => new Promise<string[]>((resolve) => {
    if (!Clerk) {
      console.error('Clerk not found on window. Please check that Clerk is enabled in theme settings'); // eslint-disable-line no-console
      resolve([]);
    }

    Clerk(
      'call',
      'recommendations/complementary',
      {
        labels: [clerkLabel],
        products: productIds,
        limit,
        attributes: ['handle'],
      },
      async (clerkResponse: ClerkResponse) => {
        const productItems = await getProductItemsFromClerkResponse(clerkResponse, 'cart-upsell-item');

        resolve(productItems);
      },
      (clerkResponse: ClerkResponse) => {
        console.error(clerkResponse.message); // eslint-disable-line no-console
        resolve([]);
      },
    );
  });

  const renderProductItems = (productItems: string[]) => {
    const html = productItems.map((item) => (
      `<li class="flex">${item}</li>`
    )).join('');
    upsellList.innerHTML = html;

    Clerk('click', '*[data-clerk-product-id]');
    document.dispatchEvent(new Event('app:mount'));
  };

  const init = async () => {
    const productItems = await fetchProductItems();
    renderProductItems(productItems);
  };

  init();
});
